<template>
    <div>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Streitwert"
                property="amountDispute"
                required
                type="currency"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Streitwert-Faktor"
                property="feeFactor"
                required
                type="autocomplete"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Berechnung nach"
                property="calculationMethod"
                required
                type="autocomplete"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Rechnungsdatum"
                property="dateReceipt"
                required
                type="date"/>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Zusatztext Gebührenposition"
                property="additionalPositionText"
                type="text"/>
        </b-row>
    </div>
</template>

<script>
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';

    export default {
        name: 'FeeCreateBasedata',
        mixins: [FormDataMixin],
    }
</script>
